export default {"src":"/_next/static/media/emb.447f9ed3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};